/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Create_Table_ValidationInputs */



/**
* | output |
* | --- |
* | "Enter a table name and at least one column." |
*
* @param {Datasets_Create_Table_ValidationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_create_table_validation = /** @type {((inputs?: Datasets_Create_Table_ValidationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Create_Table_ValidationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie einen Tabellennamen und mindestens eine Spalte ein.")
	return /** @type {LocalizedString} */ ("Enter a table name and at least one column.")
});